import type {
  GetListResponseOfUserActivitySummaryResponse,
  GetUserActivityDetailRequest,
  GetUserActivitySummaryRequest,
  UserActivityDetailResponse,
} from 'src/api/ProactApiClient';
import {userActivityApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const userActivityApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getUserActivitySummary: builder.query<
      GetListResponseOfUserActivitySummaryResponse,
      GetUserActivitySummaryRequest
    >({
      queryFn: clientQuery(params => userActivityApiClient.getSummary(params)),
    }),
    getUserActivityDetail: builder.query<
      UserActivityDetailResponse,
      GetUserActivityDetailRequest
    >({
      queryFn: clientQuery(params => userActivityApiClient.getDetail(params)),
    }),
  }),
});

export const {useGetUserActivitySummaryQuery, useGetUserActivityDetailQuery} =
  userActivityApi;
